<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="purchase-history-detail">
      <Title class="_title" :jpn="t('買取詳細履歴')" />
      <HistoryHeader />
      <div class="summary-section">
        <div class="summary-item">
          <span class="label">{{ t('査定額') }}</span>
          <div class="value">&yen;{{ summaryData.totalPrice | comma }}-</div>
        </div>
        <div class="summary-item">
          <span class="label">{{ t('査定枚数') }}</span>
          <div class="value">{{ summaryData.totalCardCount }}</div>
        </div>
        <div class="summary-item">
          <span class="label">{{ t('減額枚数') }}</span>
          <div class="value">{{ summaryData.damagedCount }}</div>
        </div>
        <div class="summary-item">
          <span class="label">{{ t('返送枚数') }}</span>
          <div class="value">{{ summaryData.canceledCount }}</div>
        </div>
      </div>
      <div class="purchase-list">
        <PurchaseCardList
          v-if="cardList && cardList.cards && cardList.cards.length > 0"
          :cardList="cardList.cards"
          :cardListTitle="t('検索結果')"
          :isHistory="true"
        />
      </div>
        <div class="button-area">
          <BlackGradationButton
            class="square-button"
            :text="translatedBackText"
            @handleSquareBtnClick="goToPurchaseHistory"
          />
        </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';
import HistoryHeader from '@/components/molecules/HistoryHeader.vue';
import PurchaseCardList from '@/components/organisms/PurchaseCardList.vue';
import { separateCharacterNumber } from '@/common/util/format';

export default {
  name: 'BuyPurchaseHistoryDetail',
  mixins: [t],

  components: {
    BaseTemplate,
    BlackGradationButton,
    Title,
    HistoryHeader,
    PurchaseCardList,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      detailPurchase: 'purchaseList/resultPurchaseHistoryDetail',
    }),
    cardList() {
      if (this.detailPurchase) {
        return this.detailPurchase;
      }
      return [];
    },
    translatedBackText() {
      return this.t('一覧に戻る');
    },
    summaryData() {
      return {
        totalPrice: this.cardList.total_price ?? 0,
        totalCardCount: this.cardList.damaged_count + this.cardList.checked_count + this.cardList.canceled_count ?? 0,
        damagedCount: this.cardList.damaged_count ?? 0,
        canceledCount: this.cardList.canceled_count ?? 0,
      };
    },
  },

  created() {
    const { historyId } = this.$route.query;
    this.$store.dispatch('purchaseList/historyDetail', { historyId });
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  methods: {
    goToPurchaseHistory() {
      this.$router.push('/purchase-history');
    },
  },
};
</script>

<style lang="scss" scoped>
._title {
  margin-top: 20px;
}
.summary-section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 20px 0;
  .summary-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .label {
      font-size: 18px;
      font-weight: bold;
      color: #d14a2f;
      margin-bottom: 2px;
    }
    .value {
      font-size: 16px;
      font-weight: bold;
      margin-left: 15px;
      background: #fff;
      padding: 5px 10px;
      border-radius: 5px;
      min-width: 60px;
      width: auto;
      text-align: center;
      border: 1px solid #ddd;
      box-shadow: 0px 0 2px rgba(0, 0, 0, 0.9);
    }
  }
}
.purchase-history-detail{
  position: relative;
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 90px;
  margin: 0px auto;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  @media screen and (min-width:767px){
    max-width: 580px;
  }
  @media screen and (min-width:1023px){
    max-width: 1000px;
  }
  .button-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    .square-button{
      width: 200px;
      height: 40px;
    }
  }
  .border-area {
    margin: 30px 10px 0;
    padding: 10px 0;
    color: $white;
  }
}

@media screen and  (max-width: $tabletWidth) {
  .purchase-history-detail{
    padding: 0 0 20px 0;
  }
}
</style>
